<template>
<div style="height: 100%;">
    <div class="spin" >
      <div style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px;"> 
            <div>
              <img
                src="../assets/images/logo2.png"
                loading="lazy"
                style="height:100px;"
              />
            </div>
          <div style="display: flex; flex: 1; align-items: center; gap: 12px; justify-content: flex-end;">
              <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                <img src="../assets/images/coin.png" width="22" alt="Coin">
                <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
              </div>
              <span
                class="avatar"
                id="avatar"
                :style="{ 'background-image': `url(${pictureUrl})` }"
              ></span>
          </div>
      </div>
      <div style="position: absolute; top: 50px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                    <div style="position: absolute; top: -10px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptionsEmpty1" :options="defaultOptionsEmpty1" :height="300" :width="300"  v-on:animCreated="handleAnimationEmpty1" />
                    </div>
                    <div style="position: absolute; top: -10px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptionsPoint1" :options="defaultOptionsPoint1" :height="300" :width="300"  v-on:animCreated="handleAnimationPoint1" />
                    </div>
                    <div style="position: absolute; top: -10px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptions1" :options="defaultOptions1" :height="300" :width="300" v-on:animCreated="handleAnimation1" />
                      <div @click="selectimage2(1)" style="position: absolute; top: 100px; width: 150px; height: 150px;" />
                    </div>


                    <div style="position: absolute; top: 190px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptionsEmpty2" :options="defaultOptionsEmpty2" :height="300" :width="300" v-on:animCreated="handleAnimationEmpty2" />
                    </div>
                    <div style="position: absolute; top: 190px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptionsPoint2" :options="defaultOptionsPoint2" :height="300" :width="300"  v-on:animCreated="handleAnimationPoint2" />
                    </div>
                    <div style="position: absolute; top: 190px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptions2" :options="defaultOptions2" :height="300" :width="300" v-on:animCreated="handleAnimation2" />
                      <div @click="selectimage2(2)" style="position: absolute; top: 100px; width: 150px; height: 150px;" />
                    </div>


                    <div style="position: absolute; top: 390px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptionsEmpty3" :options="defaultOptionsEmpty3" :height="300" :width="300" v-on:animCreated="handleAnimationEmpty3" />
                    </div>
                    <div style="position: absolute; top: 390px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptionsPoint3" :options="defaultOptionsPoint3" :height="300" :width="300"  v-on:animCreated="handleAnimationPoint3" />
                    </div>
                    <div style="position: absolute; top: 390px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
                      <lottie v-if="defaultOptions3" :options="defaultOptions3" :height="300" :width="300" v-on:animCreated="handleAnimation3" />
                      <div @click="selectimage2(3)" style="position: absolute; top: 100px; width: 150px; height: 150px;" />
                    </div>
      </div>
      
      <div style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
            <div style="display: flex; flex: 1; align-items: center; justify-content: center;">
                  <div style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;">
                      <span class="glow" ref="myBtn">
                        {{loadingtext}}
                      </span>
                  </div>
              </div> 
      </div>
      <div>
      
      </div>
  </div>
</div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
import router from "./../router";
import Lottie from './lottie.vue';
import { loadAnimation } from '@/services/lottieLoader';
import liffService from "@/services/liff";
export default {
  name: 'S1',
  async created(){
    const [animate, animBox1, animBoxEmpty, animBoxCoin] = await Promise.all([
      loadAnimation('loading'),
      loadAnimation('Box1'),
      loadAnimation('Box3'),
      loadAnimation('Box4')
    ]);
    this.defaultOptions = {animationData: animate,autoplay:true,loop:true};

    this.defaultOptions1 = { animationData: animBox1, autoplay: false, loop: true }
    this.defaultOptionsEmpty1 = { animationData: animBoxEmpty, autoplay: false, loop: false }
    this.defaultOptionsPoint1 = { animationData: animBoxCoin, autoplay: false, loop: false }
    this.defaultOptions2 = { animationData: animBox1, autoplay: false, loop: true }
    this.defaultOptionsEmpty2 = { animationData: animBoxEmpty, autoplay: false, loop: false }
    this.defaultOptionsPoint2 = { animationData: animBoxCoin, autoplay: false, loop: false }
    this.defaultOptions3 = { animationData: animBox1, autoplay: false, loop: true }
    this.defaultOptionsEmpty3 = { animationData: animBoxEmpty, autoplay: false, loop: false }
    this.defaultOptionsPoint3 = { animationData: animBoxCoin, autoplay: false, loop: false }
  },
  components: {
     'lottie': Lottie
  },
  data() {
    return {
      pictureUrl:'',
      mycoin:0,
      showLoading:true,
      isDisabled: true,
      percentage: 0,
      canOpen:false,
      loadingtext:'น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่',
      defaultOptions: null,
      defaultOptions1: null,
      defaultOptions2: null,
      defaultOptions3: null,
      defaultOptionsEmpty1: null,
      defaultOptionsEmpty2: null,
      defaultOptionsEmpty3: null,
      defaultOptionsPoint1: null,
      defaultOptionsPoint2: null,
      defaultOptionsPoint3: null,
      anim: null,
      anim1: null,
      anim2: null,
      anim3: null,
      animempty1: null,
      animempty2: null,
      animempty3: null,
      animpoint1: null,
      animpoint2: null,
      animpoint3: null,
      userId: '',
      userKey: '',
    };
  },
  mounted() {
    //   this.anim.play();
       // LIFF is already initialized by router guard
       this.loadUserData();
    //   setTimeout(() => {
    //     this.showLoading = false;
    //     this.anim.stop()
    //     setTimeout(() => {
    //       this.animempty1.hide()
    //       this.animempty2.hide()
    //       this.animempty3.hide()
    //       this.animpoint1.hide()
    //       this.animpoint2.hide()
    //       this.animpoint3.hide()
    //       this.anim1.play()
    //       this.anim2.play()
    //       this.anim3.play()
    //     }, 500)
    //   }, 2500);
    setTimeout(() => {
          this.animempty1.hide()
          this.animempty2.hide()
          this.animempty3.hide()
          this.animpoint1.hide()
          this.animpoint2.hide()
          this.animpoint3.hide()
          this.anim1.play()
          this.anim2.play()
          this.anim3.play()
        }, 500)
  },
  methods: {
    selectimage2(i) {
      if(this.canOpen) {
        this.canOpen = false;
        const item = Math.floor(Math.random() * 10) + 5;
        if(i==1) {
          this.anim1.hide()
          if(item) {
            this.animpoint1.show()
            this.animpoint1.play()
          }else{
            this.animempty1.show()
            this.animempty1.play()
          }
        }else if(i==2) {
          this.anim2.hide()
          if(item) {
            this.animpoint2.show()
            this.animpoint2.play()
          }else{
            this.animempty2.show()
            this.animempty2.play()
          }
        }else{
          this.anim3.hide()
          if(item) {
            this.animpoint3.show()
            this.animpoint3.play()
          }else{
            this.animempty3.show()
            this.animempty3.play()
          }
        }
        this.mycoin += Number(item)
        firebase.firestore().collection('scratch').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).set({
          userId:this.userId,
          createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          spin:Number(item),
          value:Number(item)
        });
        setTimeout(() => {
            this.$confirm(
            {
                message: `💎 ปังปุรีเย่!! คุณได้รับ ${item} เหรียญ😘😘`,
                button: {
                yes: 'OK'
                },
                callback: async (confirm) => {
                    if (confirm) {
                        this.sendMessageLine3(item+' เหรียญ');
                    }
                }
            });	
        }, 4000);
      }

        //this.selectimage();
    },
    handleAnimation1: function (anim) {
      this.anim1 = anim
    },
    handleAnimationEmpty1: function(anim) {
      this.animempty1 = anim
    },
    handleAnimationPoint1: function(anim) {
      this.animpoint1 = anim
    },
    handleAnimation2: function (anim2) {
      this.anim2 = anim2
    },
    handleAnimationEmpty2: function(anim) {
      this.animempty2 = anim
    },
    handleAnimationPoint2: function(anim) {
      this.animpoint2 = anim
    },
    handleAnimation3: function (anim3) {
      this.anim3 = anim3
    },
    handleAnimationEmpty3: function(anim) {
      this.animempty3 = anim
    },
    handleAnimationPoint3: function(anim) {
      this.animpoint3 = anim
    },
    handleAnimation: function (anim) {
          this.anim = anim;
    },
    
    async sendMessageLine(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "💎 "+text,
          }
      ]);
      window.liff.closeWindow();
    },
    async sendMessageLine2(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "💎 "+text,
          },
      ]);
    },
    async sendMessageLine3(text){
      await window.liff.sendMessages([{
        "type": "flex",
        "altText": 'ปังปุรีเย่!! คุณได้รับ '+text,
        "contents": {
              "type": "bubble",
              "size": "micro",
              "body": {
                "type": "box",
                "layout": "vertical",
                "contents": [
                  {
                    "type": "text",
                    "text": "ยินดีด้วยค่ะ !",
                    "color": "#CCCCCC",
                    "size": "lg",
                    "weight": "bold",
                    "align": "center"
                  },
                  {
                    "type": "image",
                    "url": "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fcoin.png?alt=media",
                    "position": "relative",
                    "size": "sm"
                  },
                  {
                    "type": "text",
                    "text": "+"+text,
                    "size": "sm",
                    "color": "#CCCCCC",
                    "align": "center",
                    "weight": "bold"
                  }
                ],
                "spacing": "xxl",
                "margin": "none",
                "action": {
                  "type": "uri",
                  "label": "action",
                  "uri": "https://liff.line.me/2006378234-72e9GVNa/reward",
                  "altUri": {
                    "desktop": "https://liff.line.me/2006378234-72e9GVNa/reward"
                  }
                },
                "background": {
                  "type": "linearGradient",
                  "angle": "0deg",
                   "startColor": "#141d26",
                   "endColor": "#7367f0"
                }
              },
              "styles": {
                "footer": {
                  "separator": true
                }
              }
            }
          }]);
      window.liff.closeWindow();
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (!window.liff.isInClient()) {
          router.replace("/login");
      }else{
          if (this.userId) {
              const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
              if (user) {
                  const u = user[Object.keys(user)[0]];
                  this.mycoin = (u.coins)?u.coins:0;
                  this.userKey = Object.keys(user)[0];
                  this.sendMessageLine2("สนใจเปิดสมบัติ พลอยใสจัดการให้หน่อย 😘😘");
                  if(moment().tz("Asia/Bangkok").format("YYYY-MM-DD") === '2026-03-28') {
                    await firebase.firestore().collection('scratch').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then(async (snapshot) => {
                      if(snapshot.exists) {
                          this.sendMessageLine("ลูกค้าเปิดหีบสมบัติไปแล้วนะคะวันนี้ รอวันใหม่นะคะ 😘😘");
                      }else{
                        await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 18:00:00').where('createdate','<=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 23:59:59').get().then(async (snapshot) => {
                          let credit = 0;
                          snapshot.forEach((doc)=>{
                            credit += Number(doc.data().qty);
                          });
                          if(credit >= 200){
                            this.loadingtext = 'น้องออโต้พร้อมแล้วเปิดหีบสมบัติ ได้เลยค่ะ😘😘';
                            this.showLoading = true;
                            this.canOpen= true;
                          }else{
                            const less = 200-Number(credit);
                            this.loadingtext = `เติมเงินอีก ${less}(200) ได้เล่นเลยค่ะ!😘😘`;
                          }
                        });
                      }
                    });
                  }else{
                    this.loadingtext = `กิจกรรมนี้เฉพาะวันที่ 28 March เท่านั้น!😘😘`;
                  }
              }else{
                router.replace("/register");
              }
          }
          this.isDisabled = false;
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  padding-left: 20%;
}
.center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
        padding-top: 50%;
        height: 100%;
      }
.glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
    }

    @-webkit-keyframes glow {
    from {
        text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
    
    to {
        text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
}
.spin {   padding: 0px;
          margin: 0px;
          overflow: hidden;
          height: 100%;
/*background: rgb(255,204,92,1);
background: radial-gradient(circle, rgba(255,204,92,1) 49%, rgba(34,193,195) 100%);*/
          background: linear-gradient(rgb(56, 150, 206), rgb(26, 69, 124));
          border-right: 2px solid #cbcbcb;
          background-image: url("../assets/images/sea.jpg");
          background-size: 100% auto;
          background-position: center top;
          background-attachment: fixed;
          background-repeat: no-repeat; /* Do not repeat the image */
          background-size: cover; 
      }
</style>